import { AppBar, Box, CssBaseline, Divider, Drawer, Grid, List, ListItem, ListItemButton, ListItemText, Paper, TextField, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getOneInByClave, postIn } from "../../services/crudCustom";
import { sendEmail } from "../../services/sendEmail";
import { SendingDialog } from "../modules/dialogs/SendingDialog";
import ApplicationBar from "../modules/ui/ApplicationBar";
import { ButtonSubmit } from "../modules/ui/ButtonSubmit";
import { GroupUserData } from "../modules/ui/GroupUserData";
import { GroupUserWorkWithFile } from "../modules/ui/GroupUserWorkWithFile";
import { InputNumber } from "../modules/ui/InputNumber";
import { SelectCountryAndRegion } from "../modules/ui/SelectCountryAndRegion";
import { SelectCustom } from "../modules/ui/SelectCustom";
import { SelectCustomWithOther } from "../modules/ui/SelectCustomWithOther";
import { processUserWorksWithFile } from "../../services/processUserWorksWithFile";
import { valFormValuesCustom } from "../validators/valFormValuesCustom";
import { generateRef } from "../../helpers/generateRef";
import moment from "moment";
import QRCode from 'qrcode';
import { renderToString } from "react-dom/server";
import { setEmailBodyConfirm } from "../../helpers/setEmailBodyConfirm";


const drawerWidth = 200;
const drawerOptions = ["Datos personales", "Datos profesionales", "Tipo de participación", "Concursos"];
const TRABAJO_DEFAULT = { 
    trabModalidad: '', 
    trabNumParticipaciones: '1',
    trabTitulo: '', 
    trabOrientacion: '', 
    trabPalabrasClave: '', 
    trabNumAutores: '1',
    trabAutores: [{
        autorNombres:'',
        autorApellidos:'',
        autorProcedencia:'',
        autorEmail:'',
    }],
    trabResumenURL: '', 
    trabResumenURLLabel: '', 
    trabResumenFile: {}, 
};

export const Rnav = () => {

    // state para los valores del evento
    const [event, setEvent] = useState({ 
        id: "",
        claveProyecto: "",
        tituloEvento: "",
        urlLogo: "",
        tabla: "",
        solicitudFolio: "",
        correoEvento: "",
    });
    
    // State para los valores del formulario
    const [formValues, setFormValues] = useState({
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partGenero: "",
        partNacionalidad: "",
        partTelefono: "",
        
        profInstitucion: "",
        profDireccion: "",
        profPais: "",
        profEstado: "",
        profGrado: "",
        profOcupacion: "",

        tipoRegistro: "",
        totalTrabajos: "",
        trabajos: [],

        concPonenciaOral: "",
        concPoster: "",

        claveProyecto: "",
        registroFecha: "",
        registroReferencia: "",

        requiereFactura: "",
        factNombre: "",
        factRFC: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        factExtranjero: "",
        factExtPais: "",
        factExtNombre: "",
        factExtConcepto: "",
        factExtUsoCFDI: "",
        compPagoFecha: "",
        compPagoURLLabel: "",
        compPagoURL: "",        
    });
    
    // state para el index del item a mostrar, al cargar se muestra el primero
    const [selectedItem, setSelectedItem] = useState(0);

    // state para saber si es ponente
    const [esPonente, setEsPonente] = useState(false);

    // State para el tipoParticipacionOptions
    const [tipoParticipacionOptions] = useState([
        {value:'Ponente', label:'Presentando uno o más trabajos | with one or more works'},
        {value:'Asistente', label:'Como asistente | As asistant'},
    ]);
    
    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);
    
    // state para el codigo QR
    const [setSrc] = useState({ qrdata:"" });

    const { 
        tituloEvento,
        urlLogo,
        correoEvento,
    } = event;

    const {
        partCorreo,
        partGenero,
        partNacionalidad,
        partTelefono,

        profInstitucion,
        profDireccion,
        profGrado,
        profOcupacion,

        tipoRegistro,
        totalTrabajos,
        trabajos,

        concPonenciaOral,
        concPoster,

        registroReferencia,
    } = formValues;

    // Al seleccionar un item del Drawer se establece el index seleccionado
    const handleDrawerSelectedItem = (index) => {
        setSelectedItem(index);
    }
    
    // Al modificar un dato en un input
    const handleInputChange = ({ target }) => {
        const { name, value } = target;

        console.log(name, value);

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }

    // Cada que cambia el pais y estado
    const handleProfessionCountryAndRegionChange = ({ country, region }) => {
        // console.log(country, region);
        setFormValues({
            ...formValues,
            profPais: country,
            profEstado: region,
        })
    }

    // Mostrar los inputs dependiendo el tipo de participacion seleccionada
    const handleTipoParticipacionChange = ({ target }) => {
        const { name, value } = target;

        console.log(name, value);
        setFormValues({
            ...formValues,
            [name]: value,
        });

        // Ponente_online

        // if (value === 'Ponente') {
        if (value === 'Ponente' || value === 'Ponente_online') {
            setEsPonente(true);
        } else {
            setEsPonente(false);
        }
    }

    // Al modificar el numero de trabajos
    const handleTotalTrabajosChange = ({ target }) => {
        const { name, value } = target;

        // console.log(name, value);
        setFormValues({
            ...formValues,
            [name]: value,
        });

        const { trabajos } = formValues;

        if (value > trabajos.length) {
            // Agrega un trabajo con la estructura completa
            trabajos.push({ ...TRABAJO_DEFAULT });
        } else {
            // Eliminar ultimo trabajo
            trabajos.pop();
        }
    }

    // Al cambiar un input tipo texto de uno de los trabajos
    const handleWorkInputChange = ({target}) => {
        const { name, value } = target;
        // En name obtenemos el nombre del input tipo texto y su indice
        console.log(name, value);
        
        // Lo que se ingrese se almacena en el elemento correcto del array 'trabajos'
        const itemName = name.slice(0, name.indexOf("-"));
        const itemIndex = name.slice(name.indexOf("-")+1, name.length) - 1;
        // console.log(itemName, itemIndex);
        trabajos[itemIndex][itemName] = value;

        setFormValues({
            ...formValues,
            trabajos: trabajos,
        });
    }

    // Al cambiar el archivo del trabajo
    const handleWorkFileChange = ({ workIndex, workFile }) => {
        console.log(workIndex, workFile);

        trabajos[workIndex]["trabResumenFile"] = workFile;
        trabajos[workIndex]["trabResumenURLLabel"] = `Trabajo ${workIndex + 1}`;
        trabajos[workIndex]["trabResumenURL"] = `https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/${registroReferencia}-${workIndex + 1}.docx`;

        setFormValues({
            ...formValues,
            trabajos: trabajos,
        });
    }

    // Al cambiar el numero de los autores
    const handleWorkTotalAutoresChange = ({workIndex, trabAutores}) => {

        trabajos[workIndex].trabAutores = trabAutores;

        setFormValues({
            ...formValues,
        });
    }


    // Procesamiento de la info
    const isDataProcessed = async() => {
        console.log("Processing data");

        // Subir los trabajos 
        if (tipoRegistro === 'Ponente') {

            const resultProcessUserWorks = await processUserWorksWithFile({ trabajos, registroReferencia });
            console.log({ resultProcessUserWorks });

            // Hubo error? return false para notificar usuario
            if (resultProcessUserWorks.success !== 1) { return false; }
        }
        // Configura lo que se va a escribir a la base de datos
        const trabajosProcessed = formValues.trabajos;

        const valuesFormated = {
            ...formValues,
            trabajos: JSON.stringify(trabajosProcessed)
        }

        // - Grabar en la base de datos
        const resultPost = await postIn({ table:event.tabla, values:valuesFormated });
        console.log({resultPost});
        // Hubo error? return false para notificar usuario y mandar correo al dev
        if (resultPost.exito !== 1) { return false; }

        // - Armar el correo de acuse y enviarlo
        const urlConfirma = `${process.env.REACT_APP_HOMEPAGE}/confirmar-registro/${registroReferencia}`;
        const urlVisualiza = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${registroReferencia}`;

        // - Data adicional, para enlaces
        const aditionalData = 
        "<h3>información adicional:</h3>" +
        "<ul>" +
        `Puede consultar los detalles de su registro en <a href=${urlVisualiza}>este enlace</a> o escaneando el codigo QR` +
        "</ul>";

        const eventValues = { tituloEvento, urlConfirma, urlVisualiza, urlLogo, aditionalData };
        
        const msgbody = renderToString( setEmailBodyConfirm({ formValues, eventValues }) );

        // - Se genera el cc
        let toccAddresses = (process.env.REACT_APP_TOBCC_FACTURACION !== '') ? event.correoEvento : '';

        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": `[${tituloEvento}] CIBNOR`,
            "message": msgbody,
            "replyto": correoEvento,
            "tocc": toccAddresses,
        });
        console.log({emailResult});

        return true;
    }


    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {

        // Mostrar waiting dialog 
        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 

        // Ocultar waiting dialog 
        setSendingForm(false);

        // Dependiendo el resultado se notifica al usuario...
        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ver más eventos',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                }
            }); 
        } else {
            // Notificar del error al usuario y enviar email a developer
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedió un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente en 12 horas.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 
            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": `Error [${event.tituloEvento}]`,
                "message": `resultDataProcessed: ${resultDataProcessed} | formValues: ${{...formValues}}`
            });
        }
    }


    // Al enviar el formulario
    const handleSubmit =async (event) => {
        event.preventDefault();

        // Validar los inputs en un componente aparte
        const validationResult = valFormValuesCustom({ formValues });
        console.log({validationResult});

        // Si la validacion no pasa, salte
        if ( !validationResult ) { return false; }
        
        // Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                // procesar data
                continueConfirmed();
            }
        })
    };


    // Al cargarse la pagina se ejecuta este codigo una sola vez
    useEffect(() => {

        const setInitialValues = async() => {
            
            // Recuperamos el evento y asignamos valores
            const PROY_RECURSOS = '20493';
            const resultProyDataLoaded = await getOneInByClave({ table:'EventosConRegistro', clave:PROY_RECURSOS });

            // Si no se obtuvo respuesta entonces
            if( !resultProyDataLoaded.exito ) {
                Swal.fire("Conexión de datos.", "Revise su servicio y recargue la página.", "warning");
            } else {
                // No existe el proyecto, muestra mensaje
                if (resultProyDataLoaded.exito === 0) {
                    Swal.fire({
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        title: "Evento no disponible",
                        text: "Comuniquese a inscripciones@cibnor.mx para mayor información.",
                        confirmButtonText: 'Catálogo de eventos',
                        icon: 'warning',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                        }
                    }); 
                };
                const ProyData = resultProyDataLoaded.data[0];
                // Asignamos los valores al state
                setEvent({ ...ProyData });

                // Titulo de la pagina / pestaña
                document.title = `${ProyData.tituloEvento} · CIBNOR`;

                // +++ Asignamos valores
                // Se genera la referencia incluyendo el proyecto
                const resultGenerateRef = generateRef({ prefix:PROY_RECURSOS });
                // Obtenemos el dato para el campo 'fechaRegistro'
                const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');

                // Asignamos los valores al state
                setFormValues({
                    ...formValues,
                    claveProyecto: PROY_RECURSOS,
                    registroFecha: dateNow,
                    registroReferencia: resultGenerateRef,
                });

                // +++ Generamos el QR
                const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${resultGenerateRef}`;
                QRCode.toDataURL( qrString )
                .then( (data) => {
                    setSrc( { qrdata:data } );
                })                
            }
        };

        setInitialValues();

    }, [ ]);
    


    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex" }} autoComplete="off">
            <CssBaseline />

            {/* Encabezado */}
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <ApplicationBar
                    // title={` - Registro en línea`}
                    title={`${event.tituloEvento} - Registro en línea | Online registration`}
                    subtitle=""
                    // logo={""}
                    logo={event.urlLogo}
                    logoVariant="square"
                />
            </AppBar>

            {/* Sidebar */}
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
                }}
            >
                <Toolbar />
                {/* Opciones */}
                <Box sx={{ overflow: "auto" }}>
                    <List>
                        {drawerOptions.map((text, index) => (
                            <ListItem key={text} disablePadding>
                                <ListItemButton onClick={ () => (handleDrawerSelectedItem(index)) }>
                                    <ListItemText primary={text} /> { (index === selectedItem) ? '•': '' }
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                    <Divider />

                </Box>

                {/* Boton submit */}
                <Grid container sx={{ p: 1 }}>
                    <Grid item xs={12}>
                        <ButtonSubmit label={`Enviar | Send`} variant={'contained'} />
                    </Grid>
                </Grid>

            </Drawer>

            {/* Contenido del item seleccionado */}
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />

                {/* Datos personales  */}
                <Grid container sx={{ display:(selectedItem === 0) ? 'flex' : 'none' }}>
                    <h5>Datos personales | Personal data</h5>
                    <GroupUserData parentCallback={handleInputChange}
                        title='' 
                        userEmail='partCorreo' 
                        userEmailLabel='Correo electrónico | Email *' 
                        userFatherName='partApellidoPaterno' 
                        userFatherNameLabel='Apellido Paterno | Last name *' 
                        userMotherName='partApellidoMaterno' 
                        userMotherNameLabel={`Apellido Materno | Mother's last name`} 
                        userName='partNombres' 
                        userNameLabel='Nombre(s) | Name *' 
                        variant='outlined' 
                    />

                    {/* Genero */}
                    <SelectCustomWithOther parentCallback={handleInputChange}
                        name={"partGenero"}
                        label={"Género | Gender *"}
                        options={[
                            {value:'Masculino', label:'Masculino | Male'},
                            {value:'Femenino', label:'Femenino | Female'},
                        ]}
                        paddingH={2}
                        paddingV={1}
                        value={partGenero}
                        variant='outlined' 
                    />

                    {/* Nacionalidad */}
                    <Grid container spacing={2} sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                id="partNacionalidad"
                                label={`Nacionalidad | Nationality *`}
                                name="partNacionalidad"
                                size="small"
                                value={partNacionalidad}
                                onChange={handleInputChange}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>

                    {/* Telefono */}
                    <InputNumber
                        parentCallback={handleInputChange}
                        defaultValue={''}
                        inputProps={{ 
                            min: 1, 
                        }}
                        label={'Teléfono | Phone number *'}
                        name={'partTelefono'}
                        paddingH={2}
                        paddingV={1}
                        value={partTelefono}
                        variant={'outlined'}
                        xs={6}
                    />
                </Grid>

                {/* Datos profesionales  */}
                <Grid container sx={{ display:(selectedItem === 1) ? 'flex' : 'none' }}>
                    <h5>Datos profesionales | Professional data</h5> 

                    {/* Institucion */}
                    <Grid container spacing={2} sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                id="profInstitucion"
                                label={`Institución | Institution *`}
                                name="profInstitucion"
                                onChange={handleInputChange}
                                size="small"
                                value={profInstitucion}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>

                    {/* Direccion institucional */}
                    <Grid container spacing={2} sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                id="profDireccion"
                                label={`Dirección institucional | Address *`}
                                name="profDireccion"
                                onChange={handleInputChange}
                                size="small"
                                value={profDireccion}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>

                    {/* Pais y estado */}
                    <SelectCountryAndRegion parentCallback={handleProfessionCountryAndRegionChange} 
                        paddingH={2}
                        paddingV={1}
                        variant="outlined" 
                    />

                    {/* Grado */}
                    <Grid item xs={12} >
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"profGrado"}
                            label={"Grado | Degree *"}
                            options={[
                                {value:'Lic', label:'Licenciatura | Bachelor'},
                                {value:'MC', label:'Maestría | Master'},
                                {value:'Dr', label:'Doctorado | PhD'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={profGrado}
                            variant='outlined' 
                        />
                    </Grid>
                    
                    {/* Ocupacion / puesto */}
                    <SelectCustomWithOther parentCallback={handleInputChange}
                        name={"profOcupacion"}
                        label={"Ocupación / puesto | Position *"}
                        options={[
                            {value:'Estudiante Licenciatura', label:'Estudiante Licenciatura | Undergraduate student'},
                            {value:'Estudiante Maestría', label:'Estudiante Maestría | Masters student'},
                            {value:'Estudiante Doctorado', label:'Estudiante Doctorado | PhD student'},
                            {value:'Posdoctorado', label:'Posdoctorado | Postdoc'},
                            {value:'Investigador', label:'Investigador | Researcher'},
                            {value:'Profesional', label:'Profesional | Professional'},
                        ]}
                        paddingH={2}
                        paddingV={1}
                        value={profOcupacion}
                        variant='outlined' 
                    />

                </Grid>

                {/* Tipo de participacion  */}
                <Grid container sx={{ display:(selectedItem === 2) ? 'flex' : 'none' }}>
                    <h5>Tipo de participación | Participation info</h5>
                    <SelectCustom 
                        parentCallback={handleTipoParticipacionChange}
                        name={"tipoRegistro"}
                        label={"Participará | You will participate *"}
                        options={ tipoParticipacionOptions }
                        paddingV={1}
                        value={tipoRegistro}
                        variant='outlined' 
                    />

                    {/* Grid si es ponente */}
                    <Grid container sx={{ display:(esPonente) ? 'flex' : 'none' }}>

                        {/* ¿Cuantos trabajos?  */}
                        <InputNumber
                            parentCallback={handleTotalTrabajosChange}
                            defaultValue={null}
                            inputProps={{ 
                                min: 1, 
                                onKeyDown: (event) => {
                                    event.preventDefault();
                                }
                            }}
                            label={'¿Cuantos trabajos? | How many works? *'}
                            name={'totalTrabajos'}
                            paddingH={0}
                            paddingV={1}
                            value={totalTrabajos}
                            variant='outlined'
                            xs={6}
                        />

                        {/* El conjunto de trabajos */}
                        {trabajos.map((text, index) => (
                            <ListItem key={index} disablePadding>
                                <Paper elevation={2} sx={{ mb: 2 }}>
    
                                    <GroupUserWorkWithFile 
                                        parentCallback={handleWorkInputChange}
                                        workTitle={`trabTitulo-${index + 1}`} 
                                        workTitleLabel={`Título del trabajo | Work title ${index + 1} *`}
                                        workTitleHelper={``}
                                        workOrientation={`trabOrientacion-${index + 1}`} 
                                        workOrientationLabel={`Orientación del trabajo | Work orientation ${index + 1} *`} 
                                        workOrientationOptions={[
                                            {value:'Ecología', label:'Ecología'},
                                            {value:'Genética', label:'Genética'},
                                            {value:'Fisiología', label:'Fisiología'},
                                            {value:'Biología del Desarrollo', label:'Biología del Desarrollo'},
                                            {value:'Biología Reproductiva', label:'Biología Reproductiva'},
                                            {value:'Acuicultura', label:'Acuicultura'},
                                            {value:'Taxonomía', label:'Taxonomía'},
                                            {value:'Sistemática', label:'Sistemática'},
                                            {value:'Filogenética', label:'Filogenética'},
                                            {value:'Ecología Pesquera', label:'Ecología Pesquera'},
                                            {value:'Pesquerías', label:'Pesquerías'},
                                            {value:'Etología', label:'Etología'},
                                            {value:'Biología de la Conservación', label:'Biología de la Conservación'},
                                            {value:'Especies en Riesgo o Extintas', label:'Especies en Riesgo o Extintas'},
                                            {value:'Especies Invasoras', label:'Especies Invasoras'},
                                            // {value:'Taxonomía y colecciones científicas', label:'Taxonomía y colecciones científicas'},
                                            // {value:'Sistemática y biogeografía', label:'Sistemática y biogeografía'},
                                            // {value:'Genética y evolución', label:'Genética y evolución'},
                                            // {value:'Desarrollo y morfofisiología', label:'Desarrollo y morfofisiología'},
                                            // {value:'Comportamiento y ecología', label:'Comportamiento y ecología'},
                                            // {value:'Bioseguridad (inocuidad y sanidad acuícola)', label:'Bioseguridad (inocuidad y sanidad acuícola)'},
                                            // {value:'Biología pesquera', label:'Biología pesquera'},
                                            // {value:'Piscicultura', label:'Piscicultura'},
                                            // {value:'Ictiología aplicada', label:'Ictiología aplicada'},
                                            // {value:'Conservación y manejo', label:'Conservación y manejo'},
                                        ]} 
                                        workModality={`trabModalidad-${index + 1}`} 
                                        workModalityLabel={`Modalidad del trabajo | Work modality ${index + 1} *`} 
                                        workModalityOptions={[
                                            {value:'Ponencia Oral', label:'Ponencia Oral'},
                                            {value:'Póster', label:'Póster'},
                                        ]} 
                                        workNumParticipaciones={`trabNumParticipaciones-${index + 1}`}
                                        workNumParticipacionesLabel={`Número de participaciones | Total participations *`}
                                        
                                        workResume={`trabResumenTexto-${index + 1}`}
                                        workResumeLabel={`Resumen del trabajo ${index + 1} *`}
                                        workResumeHelper={`Palabras restantes disponibles: `}
                                        workResumeMaxWordsCount={300}

                                        workFileCallback={ handleWorkFileChange }
                                        workFileName={`trabResumenFile-${index + 1}`}
                                        workFileNameHelper={'Subir resumen en Word | Upload Word file *'}

                                        workKeywords={`trabPalabrasClave-${index + 1}`}
                                        workKeywordsLabel={`Palabras clave | Keywords *`}
                                        workKeywordsHelper={`Máximo tres palabras clave separadas por comas | Coma separated, three keywords max`}
                                        autoresCallback={handleWorkTotalAutoresChange}
                                        workNumAutores={`trabNumAutores-${index + 1}`}
                                        workNumAutoresLabel={`Número de autores | Total authors *`}
                                        variant={'filled'}
                                    />
    
                                </Paper>
                            </ListItem>
                        ))}

                    </Grid>

                </Grid>

                {/* Concursos */}
                <Grid container sx={{ display:(selectedItem === 3) ? 'flex' : 'none' }}>
                    <h5>Concursos (solo estudiantes) | Contests (students only)</h5>

                    {/* Concurso de ponencia oral */}
                    <Grid item xs={12} >
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"concPonenciaOral"}
                            label={"¿Participará en el concurso de ponencia oral? | You will participate in the oral presentation contest?"}
                            options={[
                                {value:'Si', label:'Si | Yes'},
                                {value:'No', label:'No | No'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={concPonenciaOral}
                            variant='outlined' 
                        />
                    </Grid>
                    
                    {/* Concurso de póster */}
                    <Grid item xs={12} >
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"concPoster"}
                            label={"¿Participará en el concurso de póster? | You will participate in the poster contest?"}
                            options={[
                                {value:'Si', label:'Si | Yes'},
                                {value:'No', label:'No | No'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={concPoster}
                            variant='outlined' 
                        />
                    </Grid>

                </Grid>

            </Box>

            {/* Dialogo 'enviando la informacion' */}
            <SendingDialog show={sendingForm} />

        </Box>
    );
};
